module.exports = __webpack_public_path__ + "static/all-cultures-desktop.8cf8eb0b.webp";